module.exports = __webpack_public_path__ + "static/media/BoxPlotQ4_2.b38f98e5.svg";